import { useHistory } from "react-router-dom"
import { useTableErrorConfig } from "../../../../../../../_webui/layout/components/Table/Error/modules/useTableErrorConfig"
import { useApi } from "../useApi"
import { useTableConfig } from "../useTableConfig"
import { useVariablesAuthority } from "../useVariablesAuthority"
import { useVariablesModal } from "../useVariablesModal"

export const useVariables = () => {
  const { push } = useHistory()
  const { columnErrors } = useTableErrorConfig()
  const { columns } = useTableConfig()

  const {
    isNotAccessScreen,
    isRoleSubAdmin,
    isVisibleBtnCancel,
    isVisibleBtnUpdate,
  } = useVariablesAuthority()

  const {
    isOpen,
    isOpenUpdate,
    onCancel,
    onCancelUpdate,
    onOpen,
    onOpenUpdate,
  } = useVariablesModal()
  const {
    beforeUpload,
    bulkCheck,
    bulkDeleteData,
    bulkFileUpdate,
    bulkUpdate,
    countRecord,
    dataTemps,
    errorList,
    fileNameList,
    form,
    isDisabledSubmit,
    isLoading,
    isLoadingLayout,
    isResetTable,
    onChange,
    onChangeUploadFile,
    perItem,
  } = useApi({
    onCancel,
    onCancelUpdate,
  })

  return {
    beforeUpload,
    bulkCheck,
    bulkDeleteData,
    bulkFileUpdate,
    bulkUpdate,
    columnErrors,
    columns,
    countRecord,
    dataTemps,
    errorList,
    fileNameList,
    form,
    isDisabledSubmit,
    isLoading,
    isLoadingLayout,
    isNotAccessScreen,
    isOpen,
    isOpenUpdate,
    isResetTable,
    isRoleSubAdmin,
    isVisibleBtnCancel,
    isVisibleBtnUpdate,
    onCancel,
    onCancelUpdate,
    onChange,
    onChangeUploadFile,
    onOpen,
    onOpenUpdate,
    perItem,
    push,
  }
}
